import { ContainerController } from './ContainerController.js';
import { TabWatcher } from './TabWatcher.js';
export class TabController {
    constructor(tag, type, elements, _menu) {
        this.tag = tag;
        this.type = type;
        this.elements = elements;
        this._menu = _menu;
        this._build_functions = [];
        this._dependencies = [];
        this._tab_watcher = new TabWatcher();
        this._container_controller = new ContainerController(this.elements.container, this._tab_watcher);
        this._update_observer = this._menu.update_observable.add(() => {
            let is_dirty = false;
            for (let i = 0; i < this._dependencies.length; i++) {
                const dependency_record = this._dependencies[i];
                const result = dependency_record[0]();
                if (result !== dependency_record[1]) {
                    dependency_record[1] = result;
                    is_dirty = true;
                    break;
                }
            }
            if (is_dirty) {
                this._tab_watcher.clear();
                this._container_controller.clear();
                this._build_functions.forEach(build => build(this._container_controller));
            }
            else {
                this._tab_watcher.call();
            }
        });
    }
    set name(value) {
        this.elements.button.innerText = value;
    }
    get name() {
        return this.elements.button.innerText;
    }
    build(build_function, dependencies) {
        this._build_functions.push(build_function);
        build_function(this._container_controller);
        if (dependencies) {
            dependencies.forEach(dep => this._dependencies.push([dep, dep()]));
        }
    }
    set_active() {
        this._menu.set_active_tab(this);
    }
    remove() {
        this._menu.remove_tab(this);
    }
    dispose() {
        this._update_observer.dispose();
    }
}
//# sourceMappingURL=TabController.js.map